import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Tag } from 'antd';

function DraggablePreview(props) {
  const { value } = props;

  return (
      <Tag
        color="green"
        style={{
          opacity: 0.5,
          cursor: 'move',
        }}
      >
        <ReactMarkdown
          source={value.replace(/\*/g,'')}
          renderers={{
            paragraph: 'span'
          }}
        />
      </Tag>
  );
}

export default DraggablePreview;
